import React from 'react';
import {CardHeader, IconButton, Paper} from '@mui/material';
import {Close as CloseIcon} from '@mui/icons-material';
import {
  array,
  element,
  func,
  node,
  object,
  oneOfType,
  string,
} from 'prop-types';

const DialogTitle = ({
  icon,
  onClose,
  secondaryAction,
  title,
  titleTypographyProps,
  subheader,
  sx,
  ...props
}) => {
  return (
    <CardHeader
      title={title}
      subheader={subheader}
      titleTypographyProps={{
        component: 'h2',
        variant: 'h6',
        fontWeight: 500,
        ...titleTypographyProps,
      }}
      component={Paper}
      square
      elevation={24}
      avatar={icon}
      action={
        <>
          {secondaryAction}
          {onClose && (
            <IconButton
              aria-label="close"
              size="small"
              sx={{
                marginLeft: secondaryAction ? 1 : 0,
                color: 'action',
              }}
              onClick={() => onClose()}
              data-testid="dialog-title-close-btn"
            >
              <CloseIcon />
            </IconButton>
          )}
        </>
      }
      sx={[
        {
          boxShadow: 'none',
          borderBottom: '1px solid',
          borderColor: 'divider',
          '& .MuiCardHeader-avatar': {
            marginRight: 1,
            color: 'action.active',
            alignSelf: 'flex-start',
            marginTop: 0.5,
          },
          '& .MuiCardHeader-action': {
            marginTop: 0,
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      data-testid="dialog-title"
      {...props}
    />
  );
};

DialogTitle.propTypes = {
  /**
   * Icon element to display in front of the title
   */
  icon: element,
  /**
   * Callback fired when close button is clicked
   */
  onClose: func.isRequired,
  /**
   * String text to use as title
   */
  title: oneOfType([string, node, object, element]),
  /**
   * props forwarded to the title
   */
  titleTypographyProps: object,
  /**
   * Secondary CTA
   */
  secondaryAction: element,
  /**
   * Content to show as sub header
   */
  subheader: node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: oneOfType([array, object]),
};

export default DialogTitle;
